import { render, staticRenderFns } from "./LoadoutInfoModal.vue?vue&type=template&id=4f797495&scoped=true&"
import script from "./LoadoutInfoModal.vue?vue&type=script&lang=js&"
export * from "./LoadoutInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./LoadoutInfoModal.vue?vue&type=style&index=0&id=4f797495&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f797495",
  null
  
)

export default component.exports